import React from "react"
import Color from "color"
import { Background } from "./background-image.component"
import { isDark } from "../../utils/styles"

export const Section = ({backgroundImage, backgroundColor, className, children}) => {
  const dark = isDark(backgroundColor, backgroundImage);
  return (
    <Background
      className={`section ${dark ? 'section-dark' : 'section-light'} ${className || ''}`}
      image={backgroundImage}
      style={{
        backgroundColor: (backgroundColor
          ? backgroundColor
          : "transparent"),
      }}
    >
      <div className="">
        {children}
      </div>
    </Background>
  )
}
